import React from 'react'
import { Row, Col } from 'reactstrap'
import { Input } from 'components/inputs'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import Paper from '@material-ui/core/Paper'
import { dialogTypes } from 'dialogs'
import { AddItemButton } from 'components/buttons'
import { DatePicker } from 'components/datePicker'
import { Select } from 'components/select'

import { Validator } from 'components/validation'
import { api as storagePlacesApi } from 'store/modules/lookups/storagePlaces'

export const CreateBottlesDetails = ({ localize, classes, entity, disabled, onDateOfArrivalChange, onStoragePlaceChange, onStorageLocationChange }) => {
  return (
    <Row>
      <Col>
        <Paper variant='outlined'>
          <Table className={classes.createBottlesDetailTable} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>{localize('ordersProcessing.dateOfArrival')}</TableCell>
                <TableCell>{localize('ordersProcessing.storagePlace')}</TableCell>
                <TableCell>{localize('bottles.storageLocation')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  <div className={classes.dateOfArrival}>
                    <Validator disabled={disabled} name='dateOfArrival' value={entity.dateOfArrival} required style={{ width: 205 }}>
                      <DatePicker disabled={disabled} value={entity.dateOfArrival} onChange={onDateOfArrivalChange} />
                    </Validator>
                  </div>
                </TableCell>
                <TableCell>
                  <div className={classes.storagePlace}>
                    <AddItemButton disabled={disabled} dialogType={dialogTypes.storagePlaceDetail} onCreatedEntity={onStoragePlaceChange}>
                      <Validator disabled={disabled} name='storagePlace' value={entity.storagePlace} required>
                        <Select
                          dataSource={storagePlacesApi.get}
                          disabled={disabled}
                          value={entity.storagePlace}
                          onChange={onStoragePlaceChange}
                          nullable
                          />
                      </Validator>
                    </AddItemButton>
                  </div>
                </TableCell>
                <TableCell>
                  <div className={classes.storageLocation}>
                    <Validator disabled={disabled} name='storageLocation' value={entity.storageLocation} style={{ width: 205 }}>
                      <Input isNumeric disabled={disabled} value={entity.storageLocation} onChange={onStorageLocationChange} />
                    </Validator>
                  </div>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Paper>
      </Col>
    </Row>
  )
}